
















































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import moment from "moment";
import { Location } from "vue-router";
import { formatDateString } from "@/shared/dateString";
import { formatCurrency } from "@/shared/currency";
import { bankCustodianMap } from "@/shared/types";
import {
  InstantTransferFailureResponseModel,
  InstantTransferFailureRequest,
  transactionTypeMap,
  failureReasonMap,
  IntraBankTransactionMessageTypes,
  TransactionStatusType
} from "@/admin/types";
import Pagination from "@/shared/components/ui/Pagination.vue";
import PageSizeSelectList from "@/shared/components/ui/PageSizeSelectList.vue";
import AdminUtilityInstantTransferDetail from "./AdminUtilityInstantTransferDetail.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Paginator from "@/shared/components/ui/Paginator.vue";
import _ from "lodash";
import { useNotifierStore } from "@/shared/store/notifier";
import { useInstantTransactionFailureStore } from "@/admin/store/instantTransactionFailure";


@Component({
  components: {
    GenericLoadingSpinner,
    Pagination,
    PageSizeSelectList,
    AdminUtilityInstantTransferDetail,
    Paginator,
  }
})

export default class AdminUtilityInstantTransferFailures extends Vue {
  formatDateString = formatDateString;
  formatCurrency = formatCurrency;
  transactionTypeMap = transactionTypeMap;
  failureReasonMap = failureReasonMap;
  bankCustodianMap = bankCustodianMap;

  @Prop() pageNumber: number;
  @Prop() transactionId: string;
  @Prop() buildRoute: (query: InstantTransferFailureRequest) => Location;
  @Prop() routeToItem: (transactionId: string) => Location;
  notifierStore = useNotifierStore();
  instantTransactionFailureStore = useInstantTransactionFailureStore();

  isArchived = false;
  fromDate = "";
  toDate = "";
  filterStatusList = this.getFilterStatuses();
  filterTypeList = this.getFilterTypes();
  filterAmount = 0;
  selectAllStatus = true;
  selectAllType = true;

  created (): void {
    this.setDefaultDates();
    this.instantTransactionFailureStore.setFiltersFromStorage();
  }

  mounted (): void {
    const storedFilter = this.instantTransactionFailureStore.storedFilter;
    let requestModel = this.createRequestModel();
    if (storedFilter !== null) {
      requestModel = { ...storedFilter };
      this.filterAmount = storedFilter.amount;
      this.filterStatusList.forEach(t => {
        const item = storedFilter.statuses.find(x => x === t.status);
        t.enabled = item !== undefined;
      });
      this.filterTypeList.forEach(t => {
        const item = storedFilter.types.find(x => x === t.type);
        t.enabled = item !== undefined;
      });
      this.toDate = storedFilter.toDate;
      this.fromDate = storedFilter.fromDate;
      this.isArchived = storedFilter.isArchived;
    }
    this.pushRoute(requestModel);
  }

  @Watch("pageNumber")
  @Watch("isArchived")
  @Watch("transactionId")
  onRouteValuePageNumberChanged () {
    const requestModel = this.createRequestModel();
    this.loadComponent(requestModel);
  }

  setDefaultDates () {
    this.toDate = moment().format("MM/DD/YYYY");
    this.fromDate = moment().subtract(90, "d").format("MM/DD/YYYY");
  }

  get filterStatuses (): string {
    const filtered = this.filterStatusList.filter(t => t.enabled);
    return filtered.length + " selected";
  }

  get filterTypes (): string {
    const filtered = this.filterTypeList.filter(t => t.enabled);
    return filtered.length + " selected";
  }

  getFilterTypes () {
    return Object.values(TransactionStatusType)
      .filter(t => t !== "none")
      .map(t => ({
        enabled: !t.toLocaleLowerCase().includes("feecollection"),
        type: t,
      }));
  }

  getFilterStatuses () {
    const list = Object.values(IntraBankTransactionMessageTypes).filter(t => t !== "unknown").map(t => ({
      enabled: true,
      status: t,
    }));
    return [...new Set(list)];
  }

  statusSelectAll (event) {
    if (event) {
      this.filterStatusList = this.filterStatusList.map(t => ({ ...t, enabled: true }));
    } else {
      this.filterStatusList = this.filterStatusList.map(t => ({ ...t, enabled: false }));
    }
  }

  typeSelectAll (event) {
    if (event) {
      this.filterTypeList = this.filterTypeList.map(t => ({ ...t, enabled: true }));
    } else {
      this.filterTypeList = this.filterTypeList.map(t => ({ ...t, enabled: false }));
    }
  }

  loadComponent (requestModel: InstantTransferFailureRequest): void {
    if (this.transactionId) {
      this.instantTransactionFailureStore.loadDetailById(this.transactionId)
        .catch(_ => { /* noop */
        });
      return;
    }
    this.instantTransactionFailureStore.loadItems(requestModel)
      .catch(_ => { /* noop */
      });
  }

  get isLoading (): boolean {
    return !this.instantTransactionFailureStore.isListLoaded;
  }

  get showDetail () {
    return !!this.transactionId;
  }

  get showListing () {
    return !this.showDetail;
  }

  get fieldConfiguration () {
    return [
      { key: "transactionId", label: "" },
      { key: "custodian" },
      { key: "partnerName", label: "Partner" },
      { key: "employerName", label: "Employer" },
      { key: "firstName", label: "First Name" },
      { key: "lastName", label: "Last Name" },
      { key: "dateCreated", label: "Initial Failure" },
      { key: "dateCompleted", label: "Date Completed" },
      { key: "dateLastModified", label: "Last Modified" },
      { key: "transactionStatus", label: "Current Status" },
      { key: "messageType", label: "Transfer Type" },
      { key: "amount", label: "Amount" },
    ];
  }

  switchArchive (isChecked: boolean) {
    const q: InstantTransferFailureRequest = {
      ...this.createRequestModel(),
      pageNumber: 1,
      isArchived: isChecked,
    };
    this.pushRoute(q);
  }

  switchPage (page: number) {
    const q: InstantTransferFailureRequest = {
      ...this.createRequestModel(),
      pageNumber: page,
    };
    this.pushRoute(q);
  }

  formModel: InstantTransferFailureRequest = {
    isArchived: false,
    pageSize: 50,
    pageNumber: 1,
    amount: 0,
    fromDate: "",
    toDate: "",
    statuses: [],
    types: [],
  };

  pushRoute (requestModel: InstantTransferFailureRequest) {
    if (!_.isEqual(this.formModel, requestModel)) {
      this.formModel = { ...requestModel };
      this.$router.push(this.buildRoute(requestModel));
    }
    this.loadComponent(requestModel);
  }

  submitSearch () {
    const q = this.createRequestModel();
    const compare = { ...this.formModel, pageNumber: q.pageNumber };
    if (!_.isEqual(compare, q)) {
      q.pageNumber = 1;
    }
    this.pushRoute(q);
  }

  createRequestModel (): InstantTransferFailureRequest {
    return {
      pageSize: 50,
      pageNumber: this.pageNumber,
      isArchived: this.isArchived,
      fromDate: this.fromDate,
      toDate: this.toDate,
      amount: this.filterAmount,
      statuses: this.filterStatusList.filter(t => t.enabled).map(t => {
        const e: IntraBankTransactionMessageTypes = t.status;
        return e;
      }),
      types: this.filterTypeList.filter(t => t.enabled).map(t => {
        const e: TransactionStatusType = t.type;
        return e;
      }),
    };
  }

  clearSearch () {
    this.filterAmount = 0;
    this.filterStatusList = this.getFilterStatuses();
    this.filterTypeList = this.getFilterTypes();
    this.setDefaultDates();
    this.isArchived = false;

    const requestModel = { ...this.createRequestModel(), pageNumber: 1 };
    this.pushRoute(requestModel);
  }

  get isFormValid () {
    return !this.$validator.errors.any();
  }

  get isSearchDisabled () {
    return this.isLoading || !this.isFormValid;
  }

  get isClearDisabled () {
    return this.isLoading;
  }

  viewClick (item: InstantTransferFailureResponseModel) {
    this.$router.push(this.routeToItem(item.transactionId));
  }

  onResolveClick (item) {
    this.showResolveDetailModal = { open: true, value: item };
  }

  showResolveDetailModal = { open: false, value: null };

  onResolveDetailModalClosed (transactionId) {
    if (transactionId) {
      this.instantTransactionFailureStore.resolveById(transactionId).then(_ => {
        this.instantTransactionFailureStore.removeFromListById(transactionId);
        this.notifierStore.setSuccess("Instant Transaction Failure item has been archived.");
      });
    }
    this.showResolveDetailModal = { open: false, value: null };
  }
}
